// extracted by mini-css-extract-plugin
export default {"badge":"AdsResultsCountBadge_badge__QHdvw"};